var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group mb-1"},[_vm._m(0),_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Search..."},on:{"keyup":_vm.typeText}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"bi bi-search"})])
}]

export { render, staticRenderFns }